module.exports = __webpack_public_path__ + "img/slide2.dfc2f666.png";